const SvgMiddleware2 = (props) => (
  <>
    <circle cx={96} cy={96} r={96} fill={props.p20} opacity={0.58} />
    <path fill="#fff" stroke={props.p30} strokeMiterlimit={10} d="m96.21 47.73 46.79 80H47l49.21-80z" />
    <path
      d="M147.94 128.84c-2.12 4.95-8.63 3.13-7.88-2.2 2.12-4.95 8.63-3.13 7.88 2.2ZM98.91 44.82c3.28 4.3-1.53 9.11-5.83 5.83-3.28-4.3 1.53-9.11 5.83-5.83ZM51.94 128.84c-2.12 4.95-8.63 3.13-7.88-2.2 2.12-4.95 8.63-3.13 7.88 2.2Z"
      fill={props.p30}
    />
  </>
);

export default SvgMiddleware2;
